import App from '@/App.vue'
import axios from 'axios'

export default {
  listCompanies(cb) {
    axios.get('companies/list')
      .then(response => cb(response.data))
      .catch(error => {
        cb([]);
        App.methods.globalRequestError(error);
      });
  }
}
